import ColorModeIconDropdown from '@/theme/ColorModeIconDropdown';
import LanguageSelectorDropdown from '@/theme/LanguageSelectorDropdown';
import { GLASS_ICON_BUTTON } from '@/components/shared/glass';
import SearchTrigger from './SearchTrigger';
import UserMenu from './UserMenu';

/**
 * Desktop top bar (md+): 56px, no border and no surface of its own — it
 * sits on the backdrop, level with the logo row above the floating
 * sidebar. No page title (every page names itself in its PageHeader):
 * glass search at the start, glass utility chips at the end.
 */
export default function Header({
    canSearch,
    userName,
    userEmail,
    onLogout,
}: {
    canSearch: boolean;
    userName?: string | null;
    userEmail?: string | null;
    onLogout: () => void;
}) {
    return (
        <header className="hidden h-14 shrink-0 items-center gap-4 px-6 md:flex lg:px-8">
            <div className="flex min-w-0 flex-1">{canSearch && <SearchTrigger />}</div>
            <div className="flex shrink-0 items-center gap-1.5">
                <LanguageSelectorDropdown compact className={GLASS_ICON_BUTTON} />
                <ColorModeIconDropdown className={GLASS_ICON_BUTTON} />
                <UserMenu name={userName} email={userEmail} onLogout={onLogout} />
            </div>
        </header>
    );
}
